import { TextField } from "@mui/material";
import { checkEmail } from "./emailInput";

interface EmailRepeatInputProps {
  disabled?: boolean;
  required?: boolean;
  email: string;
  repeatEmail: string;
  setRepeatEmail: (repeatEmail: string) => void;
  error?: boolean;
  showValidation?: boolean;
  onBlur?: () => void;
}

const EmailRepeatInput = ({
  disabled,
  required,
  email,
  repeatEmail,
  setRepeatEmail,
  error,
  showValidation = true,
  onBlur,
}: EmailRepeatInputProps): React.JSX.Element => {
  const isInvalid = !checkEmail(repeatEmail, error) || email !== repeatEmail;
  const showError = showValidation && isInvalid;

  return (
    <TextField
      sx={{
        "& .MuiInputBase-root": {
          color: showError
            ? (theme) => theme.palette.error.main
            : isInvalid
              ? undefined
              : (theme) => theme.palette.success.main,
        },
      }}
      disabled={disabled}
      focused={checkEmail(repeatEmail, error)}
      color="success"
      required={required}
      fullWidth
      type="email"
      id="EmailRepeatInput"
      label="Email Adresse wiederholen"
      variant="outlined"
      value={repeatEmail}
      onChange={(event) => {
        setRepeatEmail(event.target.value);
      }}
      onBlur={onBlur}
      error={showError}
      helperText={
        !showValidation
          ? ""
          : email.includes("wbsedu")
            ? "Email Adresse darf nicht 'wbsedu' enthalten"
            : !checkEmail(repeatEmail, error)
              ? "Bitte gib eine gültige Email Adresse ein"
              : email !== repeatEmail
                ? "Die Email Adressen stimmen nicht überein"
                : ""
      }
    />
  );
};

export default EmailRepeatInput;
